import styled from 'styled-components';

const Button = styled.button<{ variant?: 'primary' | 'danger' }>`
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  background: ${({ theme, variant }) =>
    variant === 'danger' ? theme.colors.danger : theme.colors.primary};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export default Button;
